export default function validationBrief(brief, errors) {
  if (!brief.fromDate || !brief.toDate) {
    errors.push({
      message: 'listeProduitUnitaire.errors.datesRequired',
    });
  }
  if (!brief.produitLocation) {
    errors.push({
      message: 'listeProduitUnitaire.errors.produitLoc',
    });
  }
  if (brief.fromDate > brief.toDate) {
    errors.push({
      message: 'listeProduitUnitaire.errors.dateDebutGreaterDateFin',
    });
  }
}
